const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  imageServerUrl: process.env.REACT_APP_IMAGE_SERVER_URL,
  documentServerUrl: process.env.REACT_APP_DOCUMENT_SERVER_URL,
  assemblyCopyright: process.env.REACT_APP_ASSEMBLY_COPYRIGHT,
  assemblyVersion: process.env.REACT_APP_ASSEMBLY_VERSION,
  assemblyInformationalVersion: process.env.REACT_APP_ASSEMBLY_INFORMATIONAL_VERSION,
};

export default config;
